export default theme => ({
  root: {
    display: 'flex',
    borderLeft: '1px solid',
    borderColor: theme.palette.divider,
    '& .MuiSvgIcon-root': {
      width: 20,
      height: 20
    },
    '& .MuiListItem-root': {
      '& .MuiTypography-root': {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.action.active
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.action.hover
      }
    },
    overflow: 'auto'
  },
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  sectionTitle: {
    height: 36,
    flex: 0,
    '& .MuiListItemIcon-root': {
      minWidth: 32
    }
  },
  sectionContent: {
    flex: 1,
    padding: 18,
    overflow: 'auto',
    '& p': {
      marginTop: 0
    }
  },
  sections: {
    backgroundColor: theme.palette.action.hover,
    '& .MuiListItem-root': {
      width: 30,
      writingMode: 'vertical-lr',
      '& .MuiListItemIcon-root': {
        minWidth: 'auto'
      },
      '& .MuiTypography-root': {
        fontSize: 12
      }
    }
  }
});
